<template>
  <div class="right-selector">
    <!-- <van-cell-group class="right-selector__content">
      <van-field
        is-link
        readonly
        label="可用权益"
        input-align="right"
        :placeholder="disabled ? '暂无可用权益' : '请选择权益'"
        :value="selectedContent"
        @click="openPopup"
      />
    </van-cell-group> -->

    <van-popup class="right-selector__popup" v-model="showPopup" position="bottom">
      <div class="right-selector__popup__header">
        <div class="title">请选择您要消耗的权益</div>
        <div class="button--close" @click="handleUseNone">暂不使用</div>
      </div>

      <section class="right-list__wrapper">
        <div
          v-for="item in rightList"
          :key="item.rightId"
          @click="handleSelect(item)"
          class="right-list__item"
          :class="{
            'is-disabled': item.disabled,
          }"
        >
          <div class="right-info">
            <div class="right-info--top">
              <span class="right-name">{{ item.rightName }}</span>
            </div>

            <div class="right-info--bottom">
              <div>
                {{ formatDate(item.validStartDate) }}-{{ formatDate(item.validEndDate) }}
              </div>
              <div class="count">剩余{{ item.timesLeft }}次</div>
            </div>
            <span class="right-info--range">{{ "使用范围：" + item.usrRange }}</span>
            <div class="right-info--detail" @click.stop="rightDetail(item)">
              <span>详细信息</span>
              <img src="@/assets/img/car-life/icon-extend.png" class="extend" />
            </div>
          </div>

          <span class="right-checkbox__wrapper" >
            <van-checkbox
              class="right-checkbox"
              :value="selectedRightId == item.rightId"
            ></van-checkbox>
          </span>
        </div>
      </section>
    </van-popup>

    <van-dialog v-model="showDetail" confirmButtonText="确定">
      <div class="right-selector--detail">
        <van-grid column-num="2" class="title">
          <van-grid-item text="充值面额(元)" style="background: #e7f1fa" />
          <van-grid-item
            text="优惠金额(元)"
            style="background: #e7f1fa; border-right: 1px solid #cccccc"
          />
        </van-grid>
        <van-grid
          column-num="2"
          class="content"
          v-for="(item, index) in rightRuleList"
          :key="index"
        >
          <van-grid-item :text="item.skuPrice" />
          <van-grid-item
            :text="item.rightType === '2' ? '全免' : item.rightDiscount"
            style="border-right: 1px solid #cccccc"
          />
        </van-grid>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { cloneDeep } from "lodash";

const defaultKey = {
  rightName: "rightName", // 权益名称
  rightCode: "rightCode", // 权益code
  rightDiscount: "rightDiscount", // 优惠金额
  tags: "tags", // 权益标签
  timesLeft: "timesLeft", // 剩余次数
  validStartDate: "validStartDate", // 有效期起始日期
  validEndDate: "validEndDate", // 有效期截止日期
  disabled: "disabled", // 是否禁用
  rightId: "rightId", //权益id =  rightPackageCode - rightCode,自己拼
};

/**
 * 使用方法参考 `phone-charge.vue`
 *
 * 1. 可使用 `v-model` 绑定一个对象，表示选中的权益对象
 * 2. 如果权益信息的字段和组件不兼容，可传入 `keyAdapter` 属性进行适配
 * 3. 对于选中选项的展示内容，可通过 `formatter` 进行格式化
 *    `formatter` 参数为选中的权益对象，返回值展示在输入框里
 * 4. 关于禁用的权益，如果权益信息中有disabled字段，则根据disabled判断，
 *    如果没有，则需要通过 `optionDisableMethod` 属性传入一个函数，组件内部会
 *    遍历权益并调用 `optionDisableMethod`, 参数为权益信息，返回 true 代表禁用该权益
 */
export default {
  name: "right-selector",

  model: {
    prop: "value",
    event: "select",
  },

  props: {
    // 选中的权益信息，用于组件v-model
    value: Object,

    disabled: Boolean,

    label: {
      type: String,
      default: "可选权益",
    },

    placeholder: {
      type: String,
      default: "请选择权益",
    },

    // 权益选项
    rightOptions: Array,

    // 字段名调整
    keyAdapter: {
      type: Object,
    },

    // 选中内容展示格式函数, 其返回值展示在输入框里
    // formatter(value: object): string
    formatter: {
      type: Function,
    },

    // 判断权益是否禁用的方法, 参数为每条权益的信息，
    // 返回true表示禁用，false表示不禁用
    // diaabledMethod(rightInfo: object): boolean
    optionDisableMethod: {
      type: Function,
    },
  },

  data() {
    return {
      showPopup: false,
      // 传入的rightList
      rawRightList: [],
      // 调整键名后的rightList
      rightList: [],
      showDetail: false,

      rightRuleList: [],
    };
  },

  computed: {
    selectedRightId() {
      return this.value[this.adapter.rightId];
    },

    adapter() {
      return Object.assign({}, defaultKey, this.keyAdapter);
    },

    selectedContent() {
      //取rightRuleList【0】的rightDiscount
      // if (this.value && this.value.rightRuleList) {
      //   let item = this.value.rightRuleList[0];
      //   if (item) {
      //     return "-" + item.rightDiscount;
      //   }
      //   return "";
      // }
      return "";
    },
  },

  watch: {
    rightOptions: {
      handler(options) {
        this.rawRightList = cloneDeep(options);
        this.rightList = options;
        // this.rightList = this.adaptRightList(options);
      },
      immediate: true,
    },
  },

  methods: {
    openPopup() {
      if (this.disabled) return;
      this.showPopup = true;
    },

    /**
     * 适配权益列表的字段名
     * 并且把禁用的权益排在最后
     */
    adaptRightList(rightList) {
      const enabledRights = [],
        disabledRights = [];
      for (const right of rightList) {
        let info = {};
        Object.entries(this.adapter).forEach(([key, realKey]) => {
          info[key] = right[realKey];

          if (
            key === "disabled" &&
            typeof info.disabled !== "boolean" &&
            this.optionDisableMethod
          )
            info.disabled = this.optionDisableMethod(right);
        });

        if (info.disabled) disabledRights.push(info);
        else enabledRights.push(info);
      }

      return [...enabledRights, ...disabledRights];
    },

    close() {
      this.showPopup = false;
    },

    handleUseNone() {
      this.$emit("select", {});
      this.close();
    },

    handleSelect(item) {
      console.log('RIGHT', item)
      if (item.disabled) return;

      const rightIdKey =
        (this.keyAdapter && this.keyAdapter.rightId) || defaultKey.rightId;
      let rawRightInfo = this.rawRightList.find(
        (right) => right[rightIdKey] === item.rightId
      );
      //rightDiscount传出去，方便计算支付金额
      if (rawRightInfo && rawRightInfo.rightRuleList[0]) {
        let item = rawRightInfo.rightRuleList[0];
        rawRightInfo.rightDiscount = item.rightDiscount;
      }
      console.log('rightDiscount', rawRightInfo)
      this.$emit("select", rawRightInfo || {});
      this.close();
    },

    formatDate(date) {
      return dayjs(date).format("YYYY.MM.DD");
    },

    rightDetail(item) {
      this.showDetail = true;
      this.rightRuleList = item.rightRuleList;
    },
  },
};
</script>

<style lang="less">
.right-selector {
  &--detail {
    .title {
      .van-grid-item__content {
        background-color: #e7f1fa;
        border: 1px solid #cccccc;
        border-right: 0px solid #cccccc;
      }
    }
    .van-grid-item__content {
      border-left: 1px solid #cccccc;
      border-bottom: 1px solid #cccccc;
    }
  }
}
</style>

<style lang="scss" scoped>
.right-selector {
  &__content {
    height: 0.98rem;
    font-size: 0.32rem;
    .van-cell {
      padding: 0.25rem 0.4rem;
      font-size: inherit;
      height: 100%;
    }
  }

  &__popup {
    &__header {
      font-size: 0.32rem;
      padding: 0.26rem 0.4rem;
      display: flex;
      justify-content: space-between;
      box-shadow: 0px 1px 0px 0px rgba(230, 230, 230, 1);

      .title {
        font-family: PingFangSC-Medium;
      }
      .button--close {
        color: #c8c8c8;
      }
    }

    .right-list {
      &__wrapper {
        height: 8.2rem;
        overflow-y: scroll;
      }

      &__item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 2.25rem;
        border-radius: 0.16rem;
        font-size: 0.28rem;
        margin: 0.24rem 0.4rem;
        padding-left: 0.4rem;
        padding-right: 0.24rem;
        background: #ffedcf;
        border: 1px solid #e3cfad;
        border-radius: 10px;

        &.is-disabled {
          background: #F7F6F2;
          border: 1px solid #e5dac7;
          border-radius: 0.1rem;
          opacity: .7;
        }

        .right-info {
          color: #787878;
          &--top {
            margin-bottom: 0.2rem;
            // width: 5.7rem;
            line-height: 0.36rem;

            .right-name {
              font-size: 0.26rem;
              color: #474747;
              margin-right: 0.1rem;
              font-family: PingFangSC-Medium;
            }

            .right-tag {
              display: inline-block;
              font-size: 0.2rem;
              background: #ef9356;
              color: #fff;
              border-radius: 0.02rem;
              box-sizing: border-box;
              height: 0.28rem;
              line-height: 0.28rem;
              padding: 0 0.1rem;
              transform: translateY(-0.04rem);
            }
          }

          .right-info--range {
            display: inline-block;
            white-space: nowrap;
            width: 4.6rem;
            text-overflow: ellipsis;
            overflow: hidden;
          }

          &--bottom {
            color: #474747;
            font-size: 0.2rem;
            margin-bottom: 0.12rem;
            display: flex;
            flex-direction: row;
            align-items: center;

            .count {
              font-size: 0.16rem;
              margin-left: 0.15rem;
              background: #f29254;
              border-radius: 0.15rem;
              color: #fff;
              padding: 1px 0.14rem;
            }
          }

          &--detail {
            font-size: 0.2rem;
            margin-top: 0.16rem;
            display: flex;
            align-items: center;

            .extend {
              margin-left: 0.1rem;
              width: 0.24rem;
              height: 0.24rem;
            }
          }
        }

        .right-checkbox__wrapper {
          border-radius: 50%;
          background: #fff;
        }
      }
    }
  }

  &--detail {
    margin: 0.4rem;
    border-radius: 4px;

    .title {
      background: #e7f1fa;
    }

    .content {
      background: #ffffff;
    }
  }
}
</style>
